import React from "react";
import ConstrainableContext from "../contexts/ConstrainableContext";
import isConstrainable from "./is-constrainable";
import {Pipeline} from "@morningtrain/react-helpers";
import TriggerPipelineOnConstrain from "../pipes/TriggerPipelineOnConstrain";

function Constrainable(props) {

    const _constrainable = props.constrainable || isConstrainable();

    return (
        <ConstrainableContext.Provider value={_constrainable}>
            <Pipeline>
                <TriggerPipelineOnConstrain />
                {props.children}
            </Pipeline>
        </ConstrainableContext.Provider>
    );
}

Constrainable.defaultProps = {
    constrainable: null,
};

Constrainable.propTypes = {

};

export default Constrainable;
